import { Injectable } from '@angular/core';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { NumberUtils } from '@shared/util/number-utils';
import { UserActionsLoggingManager } from '@user/service/logging/user-actions-logging.manager';
import { ProjectModel } from '../model/project.model';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUtils } from '@article/util/article-utils';
import { IsProjectType } from '../model/is-project-type';

@Injectable({
  providedIn: 'root'
})
export class CorruptedDataService {

  constructor(
    private containerService: ContainerService,
    private userActionsLoggingManager: UserActionsLoggingManager,
    private projectModel: ProjectModel,
  ) {}

  public findCorruptProjectData(): ArticleContainer[] {
    const corruptScaleArticles: ArticleContainer[] = [];
    const corruptLabelArticles: ArticleContainer[] = [];
    for (const container of this.containerService.enumerateArticleContainersInGlobal()) {
      if (!NumberUtils.isNumber(container.scale.length())) {
        console.error("Detected ArticleContainer without valid scale: ", container);
        corruptScaleArticles.push(container);
      }
      const isLabelingArticle = ArticleUtils.isLabelingArticle(container.article);
      const noParent = ArticleUsageUtils.backwardConnectionAreaUsages(container.articleUsage).length === 0;
      const isMarkingCardProject = IsProjectType.markingSystem(this.projectModel.currentProject.projectType);
      if (isLabelingArticle && noParent && !isMarkingCardProject) {
        console.error('Detected ArticleContainer with empty texture area usage: ', container);
        corruptLabelArticles.push(container);
      }
    }
    if (corruptScaleArticles.length > 0) {
      this.logNaNScaledArticles();
    }
    if (corruptLabelArticles.length > 0) {
      this.logNullLabelArticles();
    }
    return [ ...corruptScaleArticles, ...corruptLabelArticles ];
  }

  private logNaNScaledArticles() {
    if(this.projectModel.currentProject.id > -1) {
      this.userActionsLoggingManager.logFunction("article_without_valid_scale_detected", this.projectInfo());
    }
  }

  private logNullLabelArticles() {
    if (this.projectModel.currentProject.id > -1) {
      this.userActionsLoggingManager.logFunction('article_with_label_null_detected', this.projectInfo());
    }
  }

  private projectInfo(): string {
    return `projectId: '${this.projectModel.currentProject.id}' version: '${this.projectModel.currentProject.currentVersion}'`;
  }
}
